import * as yup from 'yup';

export const addressSchema = yup.object({
  name: yup.string(),
  addr1: yup.string().required('Address is required'),
  addr2: yup.string(),
  city: yup.string().required('City is required'),
  state: yup.string().required('State is required'),
  postal: yup.string().required('ZIP code is required')
});
